<template>
  <div>
    <div>

      <div class="grid_line_three">
        <!-- loading_quantity_report -->
        <div class="ma-2">
          <v-card elevation="6">
            <div class="pa-3">
              <v-row>
                <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="flex">
                  <v-img height="50" max-width="60" :lazy-src="img_store" :src="img_store" />
                  <div class="pt-3 pl-4" style="font-size: 22px"><b>ยอดขายของแต่ละสาขา</b></div>
                </v-col>

                <v-col>
                  <div class="mt-4">
                    <v-select v-model="selectedStoreTable" :items="stores" item-text="store_name" item-value="id"
                      prepend-inner-icon="mdi-store" label="เลือกร้านค้า" outlined dense multiple color="#86bc3a">
                      <!-- ตัดคำในช่องที่แสดงหลังเลือกแล้ว -->
                      <template v-slot:selection="{ item }">
                        <span>
                          {{ item.store_name.length > 7
                            ? item.store_name.slice(0, 7) + '...'
                            : item.store_name
                          }}
                        </span>
                      </template>
                    </v-select>
                  </div>

                </v-col>

                <v-col>
                  <div class="mt-4">
                    <v-select color="#86bc3a" :items="month" v-model="selectedMonthTable" item-text="name"
                      item-value="id" prepend-inner-icon="mdi-calendar-month-outline" label="เดือน" hide-details="auto"
                      outlined dense></v-select>
                  </div>
                </v-col>

                <v-col>
                  <div class="mt-4">
                    <v-select color="#86bc3a" :items="year_arr" v-model="selectedYearTable" item-text="show_year"
                      item-value="year_eng" prepend-inner-icon="mdi-calendar-month-outline" label="ปี พ.ศ."
                      hide-details="auto" outlined dense></v-select>
                  </div>
                </v-col>

                <v-btn color="#86bc3a" style="margin-top: 30px; margin-right: 30px;" dark @click="onSearch">
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>

              </v-row>


              <v-card-title>
                <!-- <v-text-field v-model="search_tatol_report" color="#86bc3a" append-icon="mdi-magnify" label="ค้นหา"
                  single-line hide-details></v-text-field> -->
              </v-card-title>
              <v-data-table :headers="header_tatol_day_report" :items="data_tatol_report_list"
                :search="search_tatol_report" class="elevation-1">
                <template slot="item" slot-scope="dataDetail">
                  <tr>
                    <!-- ชื่อร้าน จัดซ้าย -->
                    <td class="text-start" :style="{ width: header_tatol_day_report[0].width }">
                      {{ dataDetail.item.store_name }}
                    </td>
                    <!-- วันที่ 1..N -->
                    <td v-for="i in daysInMonth" :key="i" class="text-left"
                      :style="{ width: header_tatol_day_report[i].width }">
                      {{ format_number(dataDetail.item[`date_${i}`] || 0) }}
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </div>
          </v-card>
        </div>
      </div>

      <div class="mb-5">
        <!-- loading_dump_report -->
        <v-card elevation="6" class="ma-2">
          <div class="pa-3">
            <v-row>
              <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="flex">
                <v-img height="50" max-width="60" :lazy-src="img_chart" :src="img_chart" />
                <div class="pt-3 pl-4" style="font-size: 22px"><b>ยอดขายของแต่ละสาขา</b></div>
                <v-btn icon color="#86bc3a" class="mt-3" style="margin-left: 47%; margin-top: 20px !important;"
                  @click="syncFilters" dark title="ซิงค์ตัวกรอง">
                  <v-icon>mdi-content-duplicate</v-icon>
                </v-btn>
              </v-col>

              <v-col>

                <div class="mt-4">
                  <v-select v-model="selectedStoreChart" :items="stores" item-text="store_name" item-value="id"
                    prepend-inner-icon="mdi-store" label="เลือกร้านค้า" outlined dense multiple color="#86bc3a">
                    <!-- ตัดคำในช่องที่แสดงหลังเลือกแล้ว -->
                    <template v-slot:selection="{ item }">
                      <span>
                        {{ item.store_name.length > 7
                          ? item.store_name.slice(0, 7) + '...'
                          : item.store_name
                        }}
                      </span>
                    </template>
                  </v-select>
                </div>
              </v-col>

              <!-- เลือกเดือน -->
              <v-col>
                <div class="mt-4">
                  <v-select color="#86bc3a" :items="month" v-model="selectedMonthChart" item-text="name" item-value="id"
                    prepend-inner-icon="mdi-calendar-month-outline" label="เดือน" hide-details="auto" outlined
                    dense></v-select>
                </div>
              </v-col>

              <!-- เลือกปี -->
              <v-col>
                <div class="mt-4">
                  <v-select color="#86bc3a" :items="year_arr" v-model="selectedYearChart" item-text="show_year"
                    item-value="year_eng" prepend-inner-icon="mdi-calendar-month-outline" label="ปี พ.ศ."
                    hide-details="auto" outlined dense></v-select>
                </div>
              </v-col>
              <v-btn color="#86bc3a" style="margin-top: 30px; margin-right: 30px;" dark @click="onSearchChart">
                <v-icon>mdi-magnify</v-icon>
              </v-btn>

              <!-- ปุ่มค้นหา -->

            </v-row>
          </div>

          <div class="pa-3" style="height: 40vh !important">
            <canvas id="myChart"></canvas>
          </div>
        </v-card>
      </div>

      <div class="grid_line_three">
        <!-- loading_quantity_report -->
        <div class="ma-2">
          <v-card elevation="6">
            <div class="pa-3">
              <v-row>
                <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="flex">
                  <v-img height="50" max-width="60" :lazy-src="img_note" :src="img_note" />
                  <div class="pt-3 pl-4" style="font-size: 22px"><b>การสั่งซื้อสินค้าของแต่ละสาขา</b></div>
                </v-col>

                <v-col>
                  <div class="mt-4"><v-select v-model="selectedStoreWholesaleTable" :items="stores"
                      item-text="store_name" item-value="id" label="เลือกร้านค้า" multiple outlined dense
                      color="#86bc3a">
                      <template #selection="{ item }">
                        {{ item.store_name.length > 7
                          ? item.store_name.slice(0, 7) + '...'
                          : item.store_name }}
                      </template>
                    </v-select></div>

                </v-col>
                <v-col>
                  <div class="mt-4"><v-select v-model="selectedWholesaleYear" :items="year_arr" item-text="show_year"
                      item-value="year_eng" label="ปี พ.ศ." outlined dense color="#86bc3a" /></div>

                </v-col>
                <v-btn @click="onSearchWholesale" color="#86bc3a" style="margin-top: 30px; margin-right: 30px;" dark>
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>


              </v-row>

              <v-card-title class="pt-0 pb-0"></v-card-title>

              <!-- ตารางรายงานยอดสั่งซื้อรายเดือน -->
              <!-- ใน <template> แทนที่เดิม -->
              <v-data-table :headers="header_tatol_month_report" :items="wholesaleReportList" class="elevation-1"
                hide-default-footer>
                <template #item="{ item }">
                  <tr>
                    <td :style="{ width: header_tatol_month_report[0].width }">
                      {{ item.store_name }}
                    </td>
                    <td v-for="(hdr, idx) in header_tatol_month_report.slice(1)" :key="idx" class="text-left"
                      :style="{ width: hdr.width }">
                      {{ format_number(item[hdr.value] || 0) }}
                    </td>
                  </tr>
                </template>
              </v-data-table>

            </div>
          </v-card>
        </div>
      </div>

      <div class="mb-5">
        <!-- loading_dump_report -->
        <v-card elevation="6" class="ma-2">
          <div class="pa-3">
            <v-row>
              <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="flex">
                <v-img height="50" max-width="60" :lazy-src="img_chart_two" :src="img_chart_two" />
                <div class="pt-3 pl-4" style="font-size: 22px"><b>กราฟเปรียบเทียบยอดสั่งซื้อของแต่ละสาขา</b></div>
                <v-btn icon color="#86bc3a" class="mt-3" style="margin-left: 19%; margin-top: 20px !important;"
                  @click="syncFiltersWholesale" dark title="ซิงค์ตัวกรอง">
                  <v-icon>mdi-content-duplicate</v-icon>
                </v-btn>
              </v-col>

              <v-col>
                <div class="mt-4">
                  <v-select v-model="selectedStoreWholesaleChart" :items="stores" item-text="store_name" item-value="id"
                    label="เลือกร้านค้า" multiple outlined dense color="#86bc3a">
                    <template #selection="{ item }">
                      {{ item.store_name.length > 7
                        ? item.store_name.slice(0, 7) + '...'
                        : item.store_name }}
                    </template>
                  </v-select>
                </div>

              </v-col>
              <v-col>
                <div class="mt-4">
                  <v-select v-model="selectedWholesaleYearChart" :items="year_arr" item-text="show_year"
                    item-value="year_eng" label="ปี พ.ศ." outlined dense color="#86bc3a" />
                </div>

              </v-col>
              <v-btn @click="onSearchWholesaleChart" color="#86bc3a" style="margin-top: 30px; margin-right: 30px;" dark>
                <v-icon>mdi-magnify</v-icon>
              </v-btn>

            </v-row>
          </div>

          <div class="pa-3" style="height: 80vh !important">
            <canvas id="myChart_store_other"></canvas>
          </div>
        </v-card>
      </div>

      <!-- loading_quantity_report -->
      <!-- <div class="grid_line_three">
        <div class="ma-2">
          <v-card elevation="6">
            <div class="pa-3">
              <v-row>
                <v-col cols="12" class="flex">
                    <v-img height="50" max-width="60" :lazy-src="img_note_chart" :src="img_note_chart"/>
                    <div class="pt-3 pl-4" style="font-size: 22px"><b>รายงานภาษีขาย</b></div>
                </v-col>

                <v-col>
                  <div class="mt-1">
                      <v-select color="#86bc3a" @input="dump_tax_report_select()" :items="data_arr" v-model="selected_year_tax_report" item-text="show_data" item-value="data" prepend-inner-icon="mdi-calendar-month-outline" label="เลือกข้อมูล" hide-details="auto" outlined dense></v-select>
                  </div>
                </v-col>

                <v-col>
                  <div class="mt-1">
                      <v-select color="#86bc3a" @input="dump_tax_report_select()" :items="month" v-model="selected_month_tax_report" item-text="name" item-value="id" prepend-inner-icon="mdi-calendar-month-outline" label="เดือน" hide-details="auto" outlined dense></v-select>
                  </div>
                </v-col>
                
                <v-col>
                  <div class="mt-1">
                      <v-select color="#86bc3a" @input="dump_tax_report_select()" :items="year_arr" v-model="selected_year_tax_report" item-text="show_year" item-value="year_eng" prepend-inner-icon="mdi-calendar-month-outline" label="ปี พ.ศ." hide-details="auto" outlined dense></v-select>
                  </div>
                </v-col>
                <v-col class="text-right">
                  <v-btn small @click="export_file(dataDetail.item.stock_id)" class="pa-5 ma-1 grad-primary-bg white--text mr-1" style="font-size: 16px"><v-icon>mdi-microsoft-excel</v-icon> Export</v-btn>
                </v-col>

              </v-row>
            
              <v-card-title>
                <v-text-field v-model="search_tatol_report" color="#86bc3a" append-icon="mdi-magnify" label="ค้นหา" single-line hide-details></v-text-field>
              </v-card-title>

              <v-data-table :headers="header_data_vat" :items="data_mock_vat" key="index" item-key="product_code" :search="search_tatol_report" mobile-breakpoint="0" >                
                <template slot="item" slot-scope="dataDetail">
                  <tr>
                    <td>{{ dataDetail.item.vat_date }}</td>
                    <td>{{ dataDetail.item.vat_bill }}</td>
                    <td>{{ dataDetail.item.vat_user }}</td>
                    <td>{{ dataDetail.item.vat_passpost }}</td>
                    <td>{{ dataDetail.item.vat_branch_sub }}</td>
                    <td>{{ dataDetail.item.vat_branch }}</td>
                    <td>{{ dataDetail.item.vat_value }}</td>
                    <td>{{ dataDetail.item.vat_vat }}</td>
                    <td>{{ dataDetail.item.vat_credit_charge }}</td>
                    <td>{{ dataDetail.item.vat_sum }}</td>
                  </tr>
                </template>
              </v-data-table>
              
            </div>
          </v-card>
        </div>
      </div> -->
   
      <div class="grid_line_three">
        <!-- loading_quantity_report -->
        <div class="ma-2">
          <v-row>

            <v-col cols="12" lg="6" xl="6">
              <v-card elevation="6">
                <div class="pa-3">

                  <v-row>
                    <v-col cols="12" class="flex">
                      <v-img class="" height="50" max-width="50" :lazy-src="img_box" :src="img_box" />
                      <div class="pt-3 pl-4" style="font-size: 22px"><b>สินค้าขายดี 10 อันดับ ประจำเดือน</b>
                        <v-btn @click="AllBestSelling" color="#86bc3a" style="margin-top: 2px; margin-left: 145px;"
                          dark>
                          ทั้งหมด
                        </v-btn>
                      </div>
                    </v-col>

                    <v-col>
                      <div class="mt-4">
                        <v-select v-model="selectedProductType" :items="productTypes" item-text="name" item-value="id"
                          prepend-inner-icon="mdi-tag-outline" label="เลือกประเภทสินค้า" multiple outlined dense
                          color="#86bc3a">
                          <template #selection="{ item }">
                            {{ item.name.length > 12 ? item.name.slice(0, 12) + '...' : item.name }}
                          </template>
                        </v-select>
                      </div>
                    </v-col>


                    <!-- เลือกเดือน -->
                    <v-col>
                      <div class="mt-4">
                        <v-select color="#86bc3a" :items="month" v-model="bestProductMonth" item-text="name"
                          item-value="id" prepend-inner-icon="mdi-calendar-month-outline" label="เดือน"
                          hide-details="auto" outlined dense>
                          <template #selection="{ item }">
                            <span>
                              {{ item === 'All' ? 'ทั้งหมด' : item.name }}
                            </span>
                          </template></v-select>
                      </div>
                    </v-col>

                    <!-- เลือกปี -->
                    <v-col>
                      <div class="mt-4">
                        <v-select color="#86bc3a" :items="year_arr" v-model="bestProductYear" item-text="show_year"
                          item-value="year_eng" prepend-inner-icon="mdi-calendar-month-outline" label="ปี พ.ศ."
                          hide-details="auto" outlined dense>
                          <template #selection="{ item }">
                            <span>
                              {{ item === 'All' ? 'ทั้งหมด' : item.show_year }}
                            </span>
                          </template></v-select>
                      </div>
                    </v-col>


                    <!-- ปุ่มค้นหา -->
                    <v-btn @click="onSearchBestSelling" color="#86bc3a" style="margin-top: 29px; margin-right: 30px;"
                      dark>
                      <v-icon>mdi-magnify</v-icon>
                    </v-btn>

                  </v-row>

                  <v-data-table :headers="header_data_mock" :items="topProducts" hide-default-footer
                    class="elevation-1">
                    <template #item="{ item }">
                      <tr>
                        <td>{{ item.no }}</td>
                        <td>{{ item.name }}</td>
                        <td class="text-left">{{ format_number(item.qty) }}</td>
                      </tr>
                    </template>
                  </v-data-table>
                </div>
              </v-card>
            </v-col>

            <v-col cols="12" lg="6" xl="6">
              <v-card elevation="6">
                <div class="pa-3">
                  <v-row>
                    <v-col cols="12" class="flex">
                      <v-img class="" height="50" max-width="50" :lazy-src="img_good" :src="img_good" />
                      <div class="pt-3 pl-4" style="font-size: 22px"><b>สาขาชายดี 10 อันดับ ประจำเดือน</b>
                        <v-btn @click="AllBestStore" color="#86bc3a" style="margin-top: 2px; margin-left: 150px;" dark>
                          ทั้งหมด
                        </v-btn>
                      </div>
                    </v-col>

                    <v-col>

                      <div class="mt-4">
                        <v-select v-model="selectedBestStore" :items="stores" item-text="store_name" item-value="id"
                          prepend-inner-icon="mdi-store" label="เลือกร้านค้า" outlined dense multiple color="#86bc3a">
                          <!-- ตัดคำในช่องที่แสดงหลังเลือกแล้ว -->
                          <template v-slot:selection="{ item }">
                            <span>
                              {{ item.store_name.length > 7
                                ? item.store_name.slice(0, 7) + '...'
                                : item.store_name
                              }}
                            </span>
                          </template>
                        </v-select>
                      </div>
                    </v-col>

                    <!-- เลือกเดือน -->
                    <v-col>
                      <div class="mt-4">
                        <v-select :items="month" v-model="selectedBestStoreMonth" item-text="name" item-value="id"
                          prepend-inner-icon="mdi-calendar-month-outline" label="เดือน" hide-details="auto" outlined
                          dense>
                          <template #selection="{ item }">
                            <span>
                              {{ item === 'All' ? 'ทั้งหมด' : item.name }}
                            </span>
                          </template>
                        </v-select>
                      </div>
                    </v-col>

                    <!-- ปี -->
                    <v-col>
                      <div class="mt-4">
                        <v-select :items="year_arr" v-model="selectedBestStoreYear" item-text="show_year"
                          item-value="year_eng" prepend-inner-icon="mdi-calendar-month-outline" label="ปี พ.ศ."
                          hide-details="auto" outlined dense>
                          <template #selection="{ item }">
                            <span>
                              {{ item === 'All' ? 'ทั้งหมด' : item.show_year }}
                            </span>
                          </template>
                        </v-select>
                      </div>
                    </v-col>
                    <v-btn color="#86bc3a" style="margin-top: 29px; margin-right: 30px;" dark
                      @click="onSearchBestStore">
                      <v-icon>mdi-magnify</v-icon>
                    </v-btn>
                  </v-row>
                  <!-- ในส่วน template -->
                  <v-data-table :headers="header_data_mock" :items="topStores" item-key="id" hide-default-footer
                    class="elevation-1">
                    <template #item="{ item, index }">
                      <tr>
                        <td>{{ index + 1 }}</td>
                        <td>{{ item.name }}</td>
                        <td class="text-left">{{ format_number(item.qty) }}</td>
                      </tr>
                    </template>
                  </v-data-table>
                </div>
              </v-card>
            </v-col>

          </v-row>

        </div>
        <v-overlay :value="overlay" class="z_index">
          <div class="text-center">
            <v-progress-circular indeterminate size="70" width="7" color="#86bc3a"></v-progress-circular>
            <div>โปรดรอสักครู่ระบบกำลังประมวลผล...</div>
          </div>
        </v-overlay>
      </div>

    </div>
  </div>
</template>

<script>
import img_store from "@/assets/store.png"
import img_chart from "@/assets/chart.png"
import img_chart_two from "@/assets/chart_two.png"
import img_note from "@/assets/note.png"
import img_note_chart from "@/assets/snack.png"
import img_box from "@/assets/box_three.png"
import img_good from "@/assets/good.png"
import { formatNumber } from "@/js/handler";
import Chart from 'chart.js/auto';
import { HTTP } from "@/axios";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Warehouse_report",
  data() {
    return {
      overlay: false,
      img_store: img_store,
      img_chart: img_chart,
      img_chart_two: img_chart_two,
      img_note: img_note,
      img_box: img_box,
      img_good: img_good,
      img_note_chart: img_note_chart,

      console_chart: null,
      selected_year: null,
      search_tatol_report: '',
      search: '',
      myChart: null,
      myChart_store_other: null,
      year: 2022,
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text': 'รายการต่อหน้า'
      },
      month: [
        { id: 1, name: 'มกราคม' },
        { id: 2, name: 'กุมภาพันธ์' },
        { id: 3, name: 'มีนาคม' },
        { id: 4, name: 'เมษายน' },
        { id: 5, name: 'พฤษภาคม' },
        { id: 6, name: 'มิถุนายน' },
        { id: 7, name: 'กรกฎาคม' },
        { id: 8, name: 'สิงหาคม' },
        { id: 9, name: 'กันยายน' },
        { id: 10, name: 'ตุลาคม' },
        { id: 11, name: 'พฤศจิกายน' },
        { id: 12, name: 'ธันวาคม' },
      ],

      year_arr: [],
      data_arr: [],
      // เก็บปี-เดือนที่ต้องการดูรายงาน
      reportYear: new Date().getFullYear(),
      reportMonth: new Date().getMonth() + 1,

      selectedStoreTable: [],
      selectedMonthTable: new Date().getMonth() + 1,
      selectedYearTable: new Date().getFullYear(),

      // 
      wholesaleReportList: [],
      selectedStoreWholesaleTable: [],
      selectedWholesaleYear: new Date().getFullYear(),

      // สำหรับกราฟ
      selectedStoreChart: [],
      selectedMonthChart: new Date().getMonth() + 1,
      selectedYearChart: new Date().getFullYear(),
      selectedStoreWholesaleChart: [],
      selectedWholesaleYearChart: new Date().getFullYear(),

      //best sell
      bestProductMonth: new Date().getMonth() + 1,
      bestProductYear: new Date().getFullYear(),
      selectedProductType: null,
      topProducts: [],
      productTypes: [],          // เก็บ list จาก API
      topStores: [],
      selectedBestStoreMonth: new Date().getMonth() + 1,
      selectedBestStoreYear: new Date().getFullYear(),
      selectedBestStore: [],


      wholesaleReportListChart: [],

      header: [
        {
          text: 'รหัสสินค้า',
          value: 'product_code',
          fixed: true,
          width: '170px',
        },
        {
          text: 'ชื่อสินค้า',
          value: 'product_name',
          fixed: true,
          width: '260px',
        },
        {
          text: 'ชื่อทางวิทยาศาสตร์',
          value: 'product_name_sci',
          fixed: true,
          width: '200px',
        },
        {
          text: 'คลังหลัก',
          value: 'mains',
          fixed: true,
          width: '180px',
        },
        {
          text: 'คลังใกล้หมดอายุ',
          value: 'expireds',
          fixed: true,
          width: '180px',
        },
        {
          text: 'คลังชำรุด',
          value: 'damages',
          fixed: true,
          width: '180px',
        },
        {
          text: 'คลังรอคืน',
          value: 'returns',
          fixed: true,
          width: '180px',
        },
        {
          text: 'คลังรอลดหนี้',
          value: 'reducts',
          fixed: true,
          width: '180px',
        },
        {
          text: 'คลังทิ้ง',
          value: 'dumps',
          fixed: true,
          width: '180px',
        },
        {
          text: 'คลังโปรโมชั่น',
          value: 'promotions',
          fixed: true,
          width: '180px',
        },
        {
          text: 'หน่วยนับ',
          value: 'unit_name',
          fixed: true,
          width: '180px',
        },
      ],

      header_tatol_day_report: [
        {
          text: 'ชื่อสาขา',
          value: 'store_name',
          fixed: true,
          width: '200px',
        },
        {
          text: 'วันที่ 1',
          value: 'date_1',
          fixed: true,
          width: '50px',
        },
        {
          text: 'วันที่ 2',
          value: 'date_2',
          fixed: true,
          width: '50px',
        },
        {
          text: 'วันที่ 3',
          value: 'date_3',
          fixed: true,
          width: '50px',
        },
        {
          text: 'วันที่ 4',
          value: 'date_4',
          fixed: true,
          width: '50px',
        },
        {
          text: 'วันที่ 5',
          value: 'date_5',
          fixed: true,
          width: '50px',
        },
        {
          text: 'วันที่ 6',
          value: 'date_6',
          fixed: true,
          width: '50px',
        },
        {
          text: 'วันที่ 7',
          value: 'date_7',
          fixed: true,
          width: '50px',
        },
        {
          text: 'วันที่ 8',
          value: 'date_8',
          fixed: true,
          width: '50px',
        },
        {
          text: 'วันที่ 9',
          value: 'date_9',
          fixed: true,
          width: '50px',
        },
      ],

      header_tatol_month_report: [
        { text: 'ชื่อร้านค้า', value: 'store_name', fixed: true, width: '200px' },
        { text: 'ม.ค.', value: 'month_1', fixed: true, width: '100px', align: 'left' },
        { text: 'ก.พ.', value: 'month_2', fixed: true, width: '100px', align: 'left' },
        { text: 'มี.ค.', value: 'month_3', fixed: true, width: '100px', align: 'left' },
        { text: 'เม.ย.', value: 'month_4', fixed: true, width: '100px', align: 'left' },
        { text: 'พ.ค.', value: 'month_5', fixed: true, width: '100px', align: 'left' },
        { text: 'มิ.ย.', value: 'month_6', fixed: true, width: '100px', align: 'left' },
        { text: 'ก.ค.', value: 'month_7', fixed: true, width: '100px', align: 'left' },
        { text: 'ส.ค.', value: 'month_8', fixed: true, width: '100px', align: 'left' },
        { text: 'ก.ย.', value: 'month_9', fixed: true, width: '100px', align: 'left' },
        { text: 'ต.ค.', value: 'month_10', fixed: true, width: '100px', align: 'left' },
        { text: 'พ.ย.', value: 'month_11', fixed: true, width: '100px', align: 'left' },
        { text: 'ธ.ค.', value: 'month_12', fixed: true, width: '100px', align: 'left' },
      ],

      // data_tatol_report_list: [
      //   {
      //     store_name: 'สาขา MAYA เชียงใหม่',
      //     date_1: 7000,
      //     date_2: 8000,
      //     date_3: 9000,
      //     date_4: 10000,
      //     date_5: 11000,
      //     date_6: 12000,
      //     date_7: 13000,
      //     date_8: 14000,
      //     date_9: 15000,
      //   },
      //   {
      //     store_name: 'สาขาโรบินสัน',
      //     date_1: 11000,
      //     date_2: 12000,
      //     date_3: 13000,
      //     date_4: 14000,
      //     date_5: 15000,
      //     date_6: 16000,
      //     date_7: 17000,
      //     date_8: 18000,
      //     date_9: 19000,
      //   },
      //   {
      //     store_name: 'สาขาเชียงราย',
      //     date_1: 20000,
      //     date_2: 21000,
      //     date_3: 22000,
      //     date_4: 23000,
      //     date_5: 24000,
      //     date_6: 25000,
      //     date_7: 26000,
      //     date_8: 27000,
      //     date_9: 28000,
      //   }
      // ],

      data_list: [],
      graph_list: [],
      header_data_mock: [
        {
          text: 'ลำดับ',
          value: 'no',
          fixed: true,
          width: '10px',
        },
        {
          text: 'ชื่อสินค้า',
          value: 'name',
          fixed: true,
          width: '170px',
        },
        {
          text: 'จำนวน',
          value: 'qty',
          fixed: true,
          width: '100px',
        },
      ],

      header_data_vat:
        [
          {
            text: 'วันที่',
            value: 'vat_date',
            fixed: true,
            width: '10px',
          },
          {
            text: 'เลขที่ใบเสร็จ',
            value: 'vat_bill',
            fixed: true,
            width: '130px',
          },
          {
            text: 'ชื่อลูกค้า',
            value: 'vat_user',
            fixed: true,
            width: '150px',
          },
          {
            text: 'เลขประจำตัวผู้เสียภาษี',
            value: 'vat_passpost',
            fixed: true,
            width: '200px',
          },
          {
            text: 'สนญ.',
            value: 'vat_branch_sub',
            fixed: true,
            width: '100px',
          },
          {
            text: 'สาขา',
            value: 'vat_branch',
            fixed: true,
            width: '100px',
          },
          {
            text: 'มูลค่าสินค้า',
            value: 'vat_value',
            fixed: true,
            width: '130px',
          },
          {
            text: 'ภาษีมูลค่าเพิ่ม',
            value: 'vat_vat',
            fixed: true,
            width: '140px',
          },
          {
            text: 'เครดิตชาร์จ',
            value: 'vat_credit_charge',
            fixed: true,
            width: '150px',
          },
          {
            text: 'รวมทั้งสิ้น',
            value: 'vat_sum',
            fixed: true,
            width: '130px',
          },

        ],

      data_mock: [
        {
          no: 1,
          name: 'inj.GLUCOSE 20 CC for *INJection* 10.-',
          qty: 324,
        },
        {
          no: 2,
          name: 'tab.CARATEN 12.5 MG.BX 100 s 1300.-',
          qty: 200,
        },
        {
          no: 3,
          name: 'wt.น้ำกลั่นปราศจากเชื้อ ANB 1000 ML. **ฝาฟ้า 55.-',
          qty: 140,
        },
        {
          no: 4,
          name: 'ยาดม IZE JELLI BALM 7 G 29.-',
          qty: 324,
        },
        {
          no: 5,
          name: 'cr.DELANIN CREAM 5G 180.-',
          qty: 300,
        },
        {
          no: 6,
          name: 'cr.SUPIROCIN OINT 5G 95.-',
          qty: 295,
        }
      ],

      // data_mock_price_good: [
      //   {
      //     no: 1,
      //     name: 'คอร์สรักษาสิว',
      //     qty: 100,
      //   },
      //   {
      //     no: 2,
      //     name: 'ซอฟต์ฟิลเลอร์ 1  CC ',
      //     qty: 88,
      //   },
      //   {
      //     no: 3,
      //     name: 'ซอฟต์ฟิลเลอร์ 3  CC ',
      //     qty: 70,
      //   },
      //   {
      //     no: 4,
      //     name: 'เมโสรักษาฝ้า กระ',
      //     qty: 74,
      //   },
      //   {
      //     no: 5,
      //     name: 'มาร์ครักษาสิว',
      //     qty: 70,
      //   },
      //   {
      //     no: 6,
      //     name: 'Treatment',
      //     qty: 68,
      //   }
      // ],

      data_mock_vat: [
        {
          vat_date: '30/01/2023',
          vat_bill: 'inv-15774124',
          vat_user: 'ชิณณวรรธน์ ปุณณัตถ์',
          vat_passpost: '-',
          vat_branch_sub: '00000',
          vat_branch: '',
          vat_value: '149.07',
          vat_vat: '10.43',
          vat_credit_charge: '-',
          vat_sum: '159.50',
        },
        {
          vat_date: '30/01/2023',
          vat_bill: 'inv-15774123',
          vat_user: 'อติวัณณ์ วริทธิ์นันท์',
          vat_passpost: '-',
          vat_branch_sub: '00000',
          vat_branch: '',
          vat_value: '84.11',
          vat_vat: '5.89',
          vat_credit_charge: '-',
          vat_sum: '90.00',
        },
        {
          vat_date: '28/01/2023',
          vat_bill: 'inv-15774122',
          vat_user: 'ชัญญากรณัฐ ฐานิศวรร์',
          vat_passpost: '1234567890123',
          vat_branch_sub: '',
          vat_branch: '00012',
          vat_value: '2,479.00',
          vat_vat: '173.53',
          vat_credit_charge: '74.37',
          vat_sum: '2,726.00',
        },
      ],

    }
  },
  methods: {
    format_date(date) {
      let formatDate = date.split('-')
      return `${formatDate[2]}-${formatDate[1]}-${formatDate[0]}`
    },
    format_number(val) {
      return formatNumber(parseFloat(val).toFixed(2));
    },
    async year_function() {
      this.year_arr = []
      let arr_year = [0, 1, 2]
      let count_year = new Date()
      let full_year = count_year.getFullYear()
      let month_selected = count_year.getMonth() + 1
      for (let i = 0; i < arr_year.length; i++) {
        let count_th = ((full_year + 543) - i);
        let count_eng = ((full_year) - i);
        this.year_arr.push({
          id: i,
          year_th: count_th,
          year_eng: count_eng,
          show_year: 'ปี ' + count_th,
        })
      }
      this.selected_month_bill_payment = month_selected
      this.selected_year_bill_payment = this.year_arr[0].year_eng
      await this.dump_bill_payment_select()

      this.selected_year = this.year_arr[0].year_eng
      await this.dump_data_select()

      this.selected_month_tax_report = month_selected
      this.selected_year_tax_report = this.year_arr[0].year_eng
      await this.dump_tax_report_select()
    },
    async dump_bill_payment_select() {
      this.credit = 0
      this.debit = 0
      await HTTP.post('/inventory/dashboards/reportpay', {
        month: this.selected_month_bill_payment,
        year: this.selected_year_bill_payment
      }).then((res) => {
        if (res.data.success === true) {
          this.credit = res.data.credit
          this.debit = res.data.debit
        }
      })
    },
    generateDayHeaders(year, month) {
      const days = new Date(year, month, 0).getDate();
      this.daysInMonth = days;
      const headers = [
        { text: 'ชื่อร้านค้า', value: 'store_name', width: '200px', align: 'start' }
      ];
      for (let i = 1; i <= days; i++) {
        headers.push({
          text: `วันที่ ${i}`,
          value: `date_${i}`,
          width: '100px',
          align: 'left'
        });
      }
      this.header_tatol_day_report = headers;
    },
    async loadProductTypes() {
      try {
        const res = await HTTP.get('/dashboards/getProductTypes');
        if (res.data.success) {
          this.productTypes = res.data.data;
        }
      } catch (err) {
        console.error('Cannot load product types', err);
      }
    },
    // ...


    async loadStores() {
      try {
        const res = await HTTP.get('/dashboards/getPartnerName');
        if (res.data.success) {
          this.stores = res.data.data;
        }
      } catch (err) {
        console.error('Cannot load stores', err);
      }
    },
    loadSaleReportByStore() {
      const storeId = this.selectedStoreId || 'null';
      const year = this.reportYear;
      const month = this.reportMonth;

      HTTP.get(`/dashboards/saleReportByPartner/${storeId}/${year}/${month}`)
        .then(res => {
          if (res.data.success) {
            this.generateDayHeaders(res.data.year, res.data.month);
            this.data_tatol_report_list = res.data.data;
          }
        })
        .catch(console.error);
    },
    loadWholesaleReport() {
      const year = this.selectedWholesaleYear;
      HTTP.get(`/dashboards/wholesaleReportByPartner/null/${year}`) // ถ้าไม่มี filter store ใช้ 'null'
        .then(res => {
          if (res.data.success) {
            this.wholesaleReportList = res.data.data;
          }
        })
        .catch(console.error);
    },

    loadBestSellingProducts() {
      // 1) เตรียมพาราม์: productType, month, year
      const types = Array.isArray(this.selectedProductType) && this.selectedProductType.length
        ? this.selectedProductType.join(',')
        : 'null';
      const month = this.selectedBestMonth || (new Date().getMonth() + 1);
      const year = this.selectedBestYear || (new Date().getFullYear());

      // 2) เรียก API
      HTTP.get(
        `/dashboards/bestSellingProductsByPartner/${types}/${month}/${year}`
      )
        .then(res => {
          if (!res.data.success) return;

          // 3) แมปข้อมูลกลับมาแสดง
          this.topProducts = res.data.top_products.map((p, idx) => ({
            no: idx + 1,
            code: p.product_code,
            name: p.product_name,
            qty: p.total_qty,
          }));
        })
        .catch(console.error);
    },
    AllBestSelling() {
      this.bestProductMonth = 'All';
      this.bestProductYear = 'All';
      HTTP.get(`/dashboards/bestSellingProductsByPartner/All/All/All`)
        .then(res => {
          if (res.data.success) {
            this.topProducts = res.data.top_products.map((p, idx) => ({
              no: idx + 1,
              code: p.product_code,
              name: p.product_name,
              qty: p.total_qty,
            }));
          }
        })
        .catch(console.error);
    },
    AllBestStore() {
      this.selectedBestStoreMonth = 'All';
      this.selectedBestStoreYear = 'All';
      HTTP.get(`/dashboards/bestSellingStoreByPartner/All/All/All`)
        .then(res => {
          if (res.data.success) {
            this.topStores = res.data.top_stores.map((p, idx) => ({
              no: idx + 1,
              id: p.store_id,
              name: p.store_name,
              qty: p.total_qty,
            }));
          }
        })
        .catch(console.error);
    },
    loadBestSellingStore() {
      const month = this.selectedBestStoreMonth || (new Date().getMonth() + 1);
      const year = this.selectedBestStoreYear || (new Date().getFullYear());

      HTTP.get(`/dashboards/bestSellingStoreByPartner/null/${month}/${year}`)
        .then(res => {
          if (!res.data.success) return;
          this.topStores = res.data.top_stores.map((s, idx) => ({
            no: idx + 1,
            id: s.store_id,
            name: s.store_name,
            qty: s.total_qty,
          }));
        })
        .catch(console.error);
    },




    syncFilters() {
      // สมมติว่า selectedStoreTable / selectedMonthTable / selectedYearTable
      // คือค่าฟิลเตอร์ของตาราง
      // และ selectedStoreChart / selectedMonthChart / selectedYearChart
      // คือค่าฟิลเตอร์ของกราฟ

      this.selectedStoreChart = Array.isArray(this.selectedStoreTable)
        ? [...this.selectedStoreTable]
        : [];
      this.selectedMonthChart = this.selectedMonthTable;
      this.selectedYearChart = this.selectedYearTable;
    },
    syncFiltersWholesale() {
      // copy จากตารางไปกราฟ
      this.selectedStoreWholesaleChart = Array.isArray(this.selectedStoreWholesaleTable)
        ? [...this.selectedStoreWholesaleTable]
        : [];
      this.selectedWholesaleYearChart = this.selectedWholesaleYear;
    },

    // เมื่อกดค้นหา
    onSearch() {
      const storeIds = Array.isArray(this.selectedStoreTable) && this.selectedStoreTable.length
        ? this.selectedStoreTable.join(',')
        : 'null';
      const year = this.selectedYearTable;
      const month = this.selectedMonthTable;
      HTTP.get(`/dashboards/saleReportByPartner/${storeIds}/${year}/${month}`)
        .then(res => {
          if (res.data.success) {
            this.generateDayHeaders(res.data.year, res.data.month);
            this.data_tatol_report_list = res.data.data;
          }
        })
        .catch(console.error);
    },
    onSearchBestSelling() {
      // 1) เตรียมพาราม์: productTypes (comma separated), เดือน, ปี
      const types = Array.isArray(this.selectedProductType) && this.selectedProductType.length
        ? this.selectedProductType.join(',')
        : 'null';
      const month = this.bestProductMonth;
      const year = this.bestProductYear;

      // 2) เรียก API
      HTTP.get(`/dashboards/bestSellingProductsByPartner/${types}/${month}/${year}`)
        .then(res => {
          if (res.data.success) {
            // 3) แปลงข้อมูลลงใน topProducts
            this.topProducts = res.data.top_products.map((item, idx) => ({
              no: idx + 1,
              name: item.product_name,
              qty: item.total_qty
            }));
          }
        })
        .catch(console.error);
    },
    onSearchBestStore() {
      // 1) เตรียมพาราม์: เอา store หลายอันมา join ด้วย comma ถ้าไม่เลือกก็ใช้ 'null'
      const storeIds = Array.isArray(this.selectedBestStore) && this.selectedBestStore.length
        ? this.selectedBestStore.join(',')
        : 'null';
      const month = this.selectedBestStoreMonth;
      const year = this.selectedBestStoreYear;

      // 2) เรียก API
      HTTP.get(`/dashboards/bestSellingStoreByPartner/${storeIds}/${month}/${year}`)
        .then(res => {
          if (res.data.success) {
            // 3) แปลงข้อมูลลงใน topStores
            this.topStores = res.data.top_stores.map((item, idx) => ({
              no: idx + 1,
              name: item.store_name,
              qty: item.total_qty
            }));
          }
        })
        .catch(console.error);
    },

    onSearchChart() {
      // ถ้าเลือกหลายร้าน จะได้ Array ให้ join ด้วย comma ไม่งั้น 'null'
      const storeIds = Array.isArray(this.selectedStoreChart) && this.selectedStoreChart.length
        ? this.selectedStoreChart.join(',')
        : 'null';
      const year = this.selectedYearChart;
      const month = this.selectedMonthChart;

      HTTP.get(`/dashboards/saleReportByPartner/${storeIds}/${year}/${month}`)
        .then(res => {
          if (!res.data.success) return;

          // 1) ปรับ header ของตาราง (จำนวนวัน)
          this.generateDayHeaders(res.data.year, res.data.month);

          // 2) เตรียม labels (1..N)
          const labels = Array.from(
            { length: res.data.days },
            (_, i) => (i + 1).toString()
          );
          function getRandomColor() {
            // สร้าง datasets จากแต่ละ storefunction getRandomColor() {
            // สุ่มค่าสีแต่ละ channel ระหว่าง 0x20–0xE0 เพื่อหลีกเลี่ยงขาวจัดและดำจัด
            const r = Math.floor(Math.random() * (0xE0 - 0x20) + 0x20);
            const g = Math.floor(Math.random() * (0xE0 - 0x20) + 0x20);
            const b = Math.floor(Math.random() * (0xE0 - 0x20) + 0x20);
            // แปลงเป็น hex สองหลัก
            const toHex = (v) => v.toString(16).padStart(2, '0');
            return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
          }

          // สร้าง palette ตามจำนวนร้าน
          const palette = res.data.data.map(() => getRandomColor());

          // 4) เตรียม datasets
          const datasets = res.data.data.map((row, idx) => ({
            label: row.store_name,
            data: labels.map((_, j) => row[`date_${j + 1}`] || 0),
            borderColor: palette[idx],
            backgroundColor: palette[idx],
            fill: false,
            tension: 0.1,
            borderWidth: 2
          }));



          // 5) สร้างหรืออัปเดตกราฟ
          if (this.myChart) this.myChart.destroy();
          const ctx = document.getElementById('myChart').getContext('2d');
          this.myChart = new Chart(ctx, {
            type: 'line',
            data: { labels, datasets },
            options: {
              responsive: true,
              maintainAspectRatio: false,
              scales: {
                x: { stacked: true },
                y: {
                  stacked: true,
                  beginAtZero: true
                }
              },
              plugins: {
                legend: { position: 'top' },
                tooltip: { mode: 'index', intersect: false }
              }
            }
          });
        })
        .catch(console.error);
    },
    onSearchWholesale() {
      const storeIds = this.selectedStoreWholesaleTable.length
        ? this.selectedStoreWholesaleTable.join(',')
        : 'null';
      const year = this.selectedWholesaleYear;

      HTTP.get(`/dashboards/wholesaleReportByPartner/${storeIds}/${year}`)
        .then(res => {
          if (!res.data.success) return;
          this.wholesaleReportList = res.data.data.map(item => {
            const row = { store_name: item.store_name };
            for (let m = 1; m <= 12; m++) {
              row[`month_${m}`] = item[`month_${m}`] || 0;
            }
            return row;
          });
        })
        .catch(console.error);
    },

    // ค้นหาเพื่ออัปเดตกราฟ
    onSearchWholesaleChart() {
      // 1) เตรียมพาราม์
      const storeIds = Array.isArray(this.selectedStoreWholesaleChart) && this.selectedStoreWholesaleChart.length
        ? this.selectedStoreWholesaleChart.join(',')
        : 'null';
      const year = this.selectedWholesaleYearChart;

      // 2) เรียก API
      HTTP.get(`/dashboards/wholesaleReportByPartner/${storeIds}/${year}`)
        .then(res => {
          if (!res.data.success) return;

          // 3) เก็บผลลัพธ์ลงตัวแปรกลาง
          const chartData = res.data.data.map(item => {
            const row = { store_name: item.store_name };
            for (let m = 1; m <= 12; m++) {
              row[`month_${m}`] = item[`month_${m}`] || 0;
            }
            return row;
          });

          // 4) แกน Y: ชื่อเดือน (labels)
          const labels = [
            'มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน',
            'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม',
            'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'
          ];

          function getRandomColor() {
            // สร้าง datasets จากแต่ละ storefunction getRandomColor() {
            // สุ่มค่าสีแต่ละ channel ระหว่าง 0x20–0xE0 เพื่อหลีกเลี่ยงขาวจัดและดำจัด
            const r = Math.floor(Math.random() * (0xE0 - 0x20) + 0x20);
            const g = Math.floor(Math.random() * (0xE0 - 0x20) + 0x20);
            const b = Math.floor(Math.random() * (0xE0 - 0x20) + 0x20);
            // แปลงเป็น hex สองหลัก
            const toHex = (v) => v.toString(16).padStart(2, '0');
            return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
          }
          // สร้าง palette ตามจำนวนร้าน
          const palette = res.data.data.map(() => getRandomColor());

          // 6) เตรียม datasets (stacked, horizontal)
          const datasets = chartData.map((row, idx) => ({
            label: row.store_name,
            data: labels.map((_, i) => row[`month_${i + 1}`]),
            backgroundColor: palette[idx % palette.length],
            borderColor: palette[idx % palette.length],
            borderWidth: 1,
            stack: 'stack1'
          }));

          // 7) สร้าง data + config
          const data = { labels, datasets };
          const config = {
            type: 'bar',
            data,
            options: {
              indexAxis: 'y',       // horizontal bar  
              responsive: true,
              maintainAspectRatio: false,
              interaction: {
                mode: 'nearest',    // จับจุดใกล้เคียงที่สุด
                axis: 'xy',         // ใช้ทั้งแกน x+y
                intersect: true     // ต้องเล็งตรงบาร์ ถึงจะแสดง
              },
              plugins: {
                tooltip: {
                  mode: 'nearest',
                  axis: 'xy',
                  intersect: true
                },
                legend: { position: 'top' }
              },
              datasets: {
                bar: {
                  barPercentage: 0.6,
                  categoryPercentage: 0.8
                }
              },
              scales: {
                x: {
                  stacked: true,
                  beginAtZero: true,
                  title: { display: true, text: 'ยอดขายรวม' }
                },
                y: {
                  stacked: true,
                  ticks: { autoSkip: false, padding: 8 }
                }
              }
            }
          };



          // 8) วาดหรืออัปเดตกราฟ
          if (this.myChart_store_other) {
            this.myChart_store_other.destroy();
          }
          const ctx = document.getElementById('myChart_store_other').getContext('2d');
          this.myChart_store_other = new Chart(ctx, config);
        })
        .catch(console.error);
    },


    chart_bar() {
      // เตรียมพาราม์
      const storeIds = Array.isArray(this.selectedStoreId) && this.selectedStoreId.length
        ? this.selectedStoreId.join(',')
        : 'null';
      const year = this.reportYear;
      const month = this.reportMonth;

      // เรียก API
      HTTP.get(`/dashboards/saleReportByPartner/${storeIds}/${year}/${month}`)
        .then(res => {
          if (!res.data.success) return;

          // สร้าง header ตาราง
          this.generateDayHeaders(res.data.year, res.data.month);

          // เตรียม labels 1..N
          const labels = Array.from(
            { length: res.data.days },
            (_, i) => (i + 1).toString()
          );
          function getRandomColor() {
            // สร้าง datasets จากแต่ละ storefunction getRandomColor() {
            // สุ่มค่าสีแต่ละ channel ระหว่าง 0x20–0xE0 เพื่อหลีกเลี่ยงขาวจัดและดำจัด
            const r = Math.floor(Math.random() * (0xE0 - 0x20) + 0x20);
            const g = Math.floor(Math.random() * (0xE0 - 0x20) + 0x20);
            const b = Math.floor(Math.random() * (0xE0 - 0x20) + 0x20);
            // แปลงเป็น hex สองหลัก
            const toHex = (v) => v.toString(16).padStart(2, '0');
            return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
          }

          // สร้าง palette ตามจำนวนร้าน
          const palette = res.data.data.map(() => getRandomColor());
          const datasets = res.data.data.map((row, idx) => ({
            label: row.store_name,
            data: labels.map((_, j) => row[`date_${j + 1}`] || 0),
            borderColor: palette[idx],
            backgroundColor: palette[idx],
            fill: false,
            tension: 0.1,
            borderWidth: 2
          }));

          // สร้างหรืออัพเดตกราฟ
          if (this.myChart) this.myChart.destroy();
          const ctx = document.getElementById('myChart').getContext('2d');
          this.myChart = new Chart(ctx, {
            type: 'line',
            data: { labels, datasets },
            options: {
              responsive: true,
              maintainAspectRatio: false,
              scales: {
                x: { stacked: true },
                y: { stacked: true, beginAtZero: true }
              }
            }
          });
        })
        .catch(console.error);
    },



    chart_line() {
      // 1) เตรียมพาราม์
      const storeIds = Array.isArray(this.selectedStoreTable) && this.selectedStoreTable.length
        ? this.selectedStoreTable.join(',')
        : 'null';
      const year = this.selectedWholesaleYearChart;

      // เรียก API
      HTTP.get(`/dashboards/wholesaleReportByPartner/${storeIds}/${year}`)
        .then(res => {
          if (!res.data.success) return;

          // เก็บผลลัพธ์ลงตัวแปรกลาง
          this.wholesaleReportList = res.data.data.map(item => {
            const row = { store_name: item.store_name };
            for (let m = 1; m <= 12; m++) {
              row[`month_${m}`] = item[`month_${m}`] || 0;
            }
            return row;
          });

          // เตรียม labels (ชื่อเดือน)
          const labels = [
            'มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน',
            'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม',
            'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'
          ];

          function getRandomColor() {
            // สร้าง datasets จากแต่ละ storefunction getRandomColor() {
            // สุ่มค่าสีแต่ละ channel ระหว่าง 0x20–0xE0 เพื่อหลีกเลี่ยงขาวจัดและดำจัด
            const r = Math.floor(Math.random() * (0xE0 - 0x20) + 0x20);
            const g = Math.floor(Math.random() * (0xE0 - 0x20) + 0x20);
            const b = Math.floor(Math.random() * (0xE0 - 0x20) + 0x20);
            // แปลงเป็น hex สองหลัก
            const toHex = (v) => v.toString(16).padStart(2, '0');
            return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
          }

          // สร้าง palette ตามจำนวนร้าน
          const palette = res.data.data.map(() => getRandomColor());

          // เตรียม datasets จาก wholesaleReportList
          const datasets = this.wholesaleReportList.map((row, idx) => ({
            label: row.store_name,
            data: labels.map((_, i) => row[`month_${i + 1}`]),
            backgroundColor: palette[idx % palette.length],
            borderColor: palette[idx % palette.length],
            borderWidth: 1,
            stack: 'stack1'
          }));

          // สร้าง data/config สำหรับ Chart.js
          const data = { labels, datasets };
          const config = {
            type: 'bar',
            data,
            options: {
              indexAxis: 'y',       // horizontal bar
              responsive: true,
              maintainAspectRatio: false,
              interaction: {
                mode: 'index',      // ดูข้อมูลทุก dataset ในแถวเดียวกัน
                axis: 'x',          // ใช้แกน X เป็นตัวอ้างอิง (แก้จาก default)
                intersect: false
              },
              plugins: {
                tooltip: {
                  mode: 'index',
                  axis: 'x',
                  intersect: false
                },
                legend: { position: 'top' }
              },
              datasets: {
                bar: {
                  barPercentage: 0.6,
                  categoryPercentage: 0.8
                }
              },
              scales: {
                x: {
                  stacked: true,
                  beginAtZero: true,
                  title: { display: true, text: 'ยอดขายรวม' }
                },
                y: {
                  stacked: true,
                  ticks: { autoSkip: false, padding: 8 }
                }
              }
            }
          };

          if (this.myChart_store_other) this.myChart_store_other.destroy();
          const ctx = document.getElementById('myChart_store_other').getContext('2d');
          this.myChart_store_other = new Chart(ctx, config);
        })
        .catch(console.error);
    },


    async get_data() {
      this.overlay = true
      await HTTP.post('/inventory/dashboards/amount')
        .then((res) => {
          if (res.data.success === true) {
            this.product_expireds = res.data.object.product_expireds
            this.low_stock = res.data.object.low_stock
            this.cn = res.data.object.cn
            this.promotion_expireds = res.data.object.promotion_expireds
            this.promotion_mains = res.data.object.promotion_mains
            if (res.data.object.promotion_sets) {
              this.promotion_sets = res.data.object.promotion_sets
            }
            this.mains = res.data.object.mains
            this.expireds = res.data.object.expireds
            this.damages = res.data.object.damages
            this.returns = res.data.object.returns
            this.reducts = res.data.object.reducts
            this.dumps = res.data.object.dumps
            this.product_set_price = res.data.object.product_set_price
            this.product_low_cost = res.data.object.product_low_cost
            this.product_high_cost = res.data.object.product_high_cost
            this.product_not_set_price = res.data.object.product_not_set_price
            this.product_close = res.data.object.product_close
          }
        })
    },
    async get_data_table() {
      await HTTP.post('/inventory/dashboards/productswarehouse', {
        limit: 0
      }).then((res) => {
        if (res.data.success === true) {
          this.overlay = false
          this.data_list = res.data.object
        }
      })
    },

    continue_qty() {
      const id = 1
      this.$router.push('/warehousereport/warehousequantity/' + id)
    },
  },
  mounted() {
    this.year_function()
    this.get_data()
    this.get_data_table()
    this.chart_bar()
    this.chart_line()
    this.loadSaleReportByStore()
    this.loadStores()
    this.loadWholesaleReport()
    this.loadBestSellingProducts()
    this.loadProductTypes()
    this.loadBestSellingStore()
    this.generateDayHeaders(this.reportYear, this.reportMonth)
    const current = new Date();
    for (let i = 0; i < 3; i++) {
      const yEng = current.getFullYear() - i;
      this.year_arr.push({ year_eng: yEng, show_year: `ปี ${yEng + 543}` });
    }
  }
}
</script>

<style scoped>
.grid_line_first {
  display: grid;
  grid-template-columns: 55% 45%;
  grid-gap: 15px 0;
}

.grid_three {
  display: grid;
  grid-template-columns: 33.33% 33.33% 33.33%;
  grid-gap: 15px 0;
}

.grid_three_stock {
  display: grid;
  grid-template-columns: 33.33% 33.33% 33.33%;
  grid-gap: 15px 0;
}

.grid_line_second {
  display: grid;
  grid-template-columns: 30% 70%;
  grid-gap: 15px 0;
}

.hover_text {
  cursor: pointer;
  color: black !important;
  transition: 0.1s;
}

.hover_text:hover {
  color: #8cc63e !important;
  transition: 0.1s;
}

.grid_count {
  display: grid;
  grid-template-columns: 25% 75%;
}

.grid_header {
  display: grid;
  grid-template-columns: 15% 85%;
}

.grid_header_product {
  display: grid;
  grid-template-columns: 20% 80%;
}

.grid_header_drop {
  display: grid;
  grid-template-columns: 10% 90%;
}

.grid_select {
  display: grid;
  grid-template-columns: 80% 20%;
}

.grid_header_quantity {
  display: grid;
  grid-template-columns: 5% 95%;
}

.bill_payment_select {
  width: 80%;
  margin-left: auto;
}

.bill_payment_detail {
  display: grid;
  grid-template-columns: 25% 75%;
}

.grid_select_tax_report {
  display: grid;
  grid-template-columns: 35% 65%;
}

.grid_select_tax_report_excel {
  text-align: right;
}

@media only screen and (max-width: 1180px) {
  .grid_line_first {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }

  .grid_header_product {
    display: grid;
    grid-template-columns: 10% 90%;
  }

  .grid_header_drop {
    display: grid;
    grid-template-columns: 13% 87%;
  }

  .grid_line_second {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }

  .grid_header_quantity {
    display: grid;
    grid-template-columns: 10% 90%;
  }

  .bill_payment_select {
    width: 100%;
    margin-left: unset;
  }

  .bill_payment_list {
    display: grid;
    grid-template-columns: 50% 50%;
  }

  .grid_select_tax_report {
    display: grid;
    grid-template-columns: 100%;
  }

  .grid_select_tax_report_excel {
    text-align: unset;
    width: 100%;
  }

  .grid_select_tax_report_excel_button {
    width: 100%;
  }
}

@media only screen and (max-width: 500px) {
  .grid_three {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }

  .grid_line_second {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }

  .grid_header_product {
    display: grid;
    grid-template-columns: 25% 75%;
  }

  .grid_select {
    display: grid;
    grid-template-columns: 100%;
  }

  .grid_header_drop {
    display: grid;
    grid-template-columns: 25% 75%;
  }

  .grid_header_quantity {
    display: grid;
    grid-template-columns: 25% 75%;
  }

  .grid_header {
    display: grid;
    grid-template-columns: 30% 70%;
  }

  .grid_three_stock {
    display: grid;
    grid-template-columns: 50% 50%;
    grid-gap: 15px 0;
  }

  .bill_payment_detail {
    display: grid;
    grid-template-columns: 50% 50%;
  }
}
</style>
